<script setup>
import { computed } from 'vue';
import { getStandardPieChartConfig } from 'JIX/highcharts/configs/pie_chart.js';

const props = defineProps({
    dataset: {
        type: Object,
        required: true,
    }
});

const config = computed(() => getStandardPieChartConfig({
    chart: {
        type: 'pie'
    },
    title: {
        text: props.dataset.title,
    },
    series: [ {
        data: props.dataset.data,
    } ]
}));

</script>

<template>
    <Highcharts :options="config" />
</template>
